<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="350" persistent>
      <v-card>
        <v-card-title
          class="headline body-1 blue-grey darken-1 lighten-1 white--text font-weight-thin"
          primary-title
        >
          <v-icon class="white--text mr-2">mdi-shield-lock</v-icon>Código de
          Confirmação
        </v-card-title>
        <v-card-text class="pa-8">
          <v-form novalidate ref="form" v-model="valid" lazy-validation>
            <v-text-field
              v-model="newPassword"
              :rules="pwdRules"
              label="Digite o código de confirmaação"
              required
              filled
            ></v-text-field>
            <v-card-actions>
              <v-btn
                color="blue-grey lighten-2"
                text
                block
                @click="updatePinModal"
                :disabled="!valid"
                :loading="loading"
              >
                Confirmar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-grey lighten-2" text @click="dialog = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import eventBus from "../../../../main";
export default {
  name: "ModalUpdatePin",
  data: () => ({
    newPassword: "",
    repeatPassword: "",
    dialog: false,
    valid: false,
    value: true,
    loading: false,
    pwdRules: [
      v => !!v || "Código de confirmação é requerido",
      v => (v && v.length >= 6) || "Deve ter no mínimo 6 caracter"
    ]
  }),
  methods: {
    updatePinModal() {
      if (this.$refs.form.validate()) {
        let payload = {
          pin: "",
          key: this.newPassword
        };
        this.$store.dispatch("updateAndCreatePin", payload);
      }
    }
  },
  created() {
    const self = this;
    eventBus.$on("openModalUpdatePin", function(value) {
      self.dialog = value;
      self.newPassword = "";
    });
  }
};
</script>

<style scoped>
.m-center {
  text-align: center;
}
</style>
